module.exports = __webpack_public_path__ + "img/common-status-pending.26c059b6.svg";